require('es6-promise').polyfill();

const serviceClient = require('./api');
const { dynamicMethods } = require('./api');

module.exports = serviceClient;

module.exports.dynamicMethods = dynamicMethods;
